import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createOrReplyFeedback } from "@/redux/slices/feedbackSlice";
import { toast } from "react-toastify";
const ReplyModal = ({
  showModal,
  setShowModal,
  tourId,
  userId,
  parentFeedbackId,
}) => {
  const dispatch = useDispatch();

  const { loading, error } = useSelector((state) => state.feedback);

  const [feedbackData, setFeedbackData] = useState({
    userId: userId,
    tourId: tourId,
    comments: "",
    parentFeedbackId: parentFeedbackId,
  });

  const handleChange = (e) => {
    setFeedbackData({ ...feedbackData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    feedbackData.parentFeedbackId = parentFeedbackId;
    try {
      dispatch(createOrReplyFeedback(feedbackData)).unwrap();
    } catch (e) {
      toast.error("Has error when reply feedback");
      return;
    }

    setShowModal(false);
    toast.success("Reply feedback successfully");
  };
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header>
        <Modal.Title>Reply a Review</Modal.Title>
        <a
          href="#"
          data-bs-dismiss="modal"
          aria-label="Close"
          style={{ position: "absolute", right: "16px" }}
          onClick={(e) => {
            e.preventDefault();
            setShowModal(false);
          }}
        >
          <i class="ti ti-x fs-16" style={{ fontSize: "2rem" }}></i>
        </a>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div class="row">
            <div class="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>
                  Write Your Reply <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="comments"
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button type="submit" variant="primary">
            <i className="isax isax-edit-2 me-1"></i>Submit Reply
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ReplyModal;
